import React from 'react';
import { Column } from 'rbx';
import styled from 'styled-components';

const Container = styled(Column.Group)`
  border-bottom: 1px solid #b0b0b0;
`;

const ItemWithVariant = ({ itemVariant }) => (
  <>
    <Container>
      <Column size={6}>{itemVariant.variant_name}</Column>
      <Column size={6} style={{ fontSize: '13px' }}>
        <Column.Group>
          <Column size={5} style={{ color: '#00AEEF', fontSize: '16px' }}>
            ${parseFloat(itemVariant.variant_price || 0).toFixed(2)}
          </Column>
        </Column.Group>
      </Column>
    </Container>
  </>
);

export default ItemWithVariant;
